import { PlayCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd'
import message from 'components/CustomMessage';
import React, { useCallback, useState } from 'react'
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import AuthorisedContainer from 'components/AuthorisedContainer'
import { PermissionSetMap } from 'constants/RBACConstants'

function RunOnDemand({ toolName, updateConfig, disableSyncProject, buttonText = 'Sync tool projects' }) {
    const [loading, setLoading] = useState(false)
    const onToolRunDemand = useCallback(async() =>  {
        setLoading(true)
        try {
            await ToolsIntegrationsAPI.postToolRunOnDemand(toolName).promise
            updateConfig(true)
            message.success("Syncing tool images, it may take some time.");
        } catch(e) {
            console.error(e);
        } finally {
            setLoading(false)
        }
    }, [toolName, updateConfig])  
    return (
        <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS} >
            <Button className='m-l-xs' size="small" onClick={onToolRunDemand} loading={loading} disabled={disableSyncProject}><PlayCircleOutlined />{buttonText}</Button>
        </AuthorisedContainer>
    )
}

export default RunOnDemand

